module.exports = __webpack_public_path__ + "static/media/exoma.c7b8b436.png";